import { render, staticRenderFns } from "./SidebarLink.vue?vue&type=template&id=e55bc8f0&"
import script from "./SidebarLink.vue?vue&type=script&lang=js&"
export * from "./SidebarLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e55bc8f0')) {
      api.createRecord('e55bc8f0', component.options)
    } else {
      api.reload('e55bc8f0', component.options)
    }
    module.hot.accept("./SidebarLink.vue?vue&type=template&id=e55bc8f0&", function () {
      api.rerender('e55bc8f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sidebar/SidebarLink.vue"
export default component.exports